import { AbstractControl, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';
import { dateFormatValidator } from '../../../validators/date-format.validator';

// The SIN input is masked as "--- --- ###" — only the last 3 digits are collected
function lastThreeSinDigitsValidator(control: AbstractControl): ValidationErrors | null {
  if (!control.value) {
    return null;
  }
  const digits = String(control.value).replace(/\D/g, '');
  return digits.length === 3 ? null : { sinLastThreeDigits: true };
}

export type MemberWelcomeFormGroup = FormGroup<{
  birthdate: FormControl<string>;
  sin: FormControl<string>;
}>;

export function createMemberWelcomeFormGroup(): MemberWelcomeFormGroup {
  return new FormGroup({
    birthdate: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, dateFormatValidator]
    }),
    sin: new FormControl<string>('', {
      nonNullable: true,
      validators: [Validators.required, lastThreeSinDigitsValidator]
    })
  });
}
